export default "__VITE_ASSET__013c1fe5__"